import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card } from "@/components/kit";

const CHUNK = 4 * 1024 * 1024;

async function uploadChunked(file, onProgress) {
  const { upload_id } = await api("/master/platform-backups/upload", { method: "POST", body: { filename: file.name, size: file.size } });
  for (let i = 0; i < file.size; i += CHUNK) {
    await api(`/master/platform-backups/upload/${upload_id}`, { method: "PUT", body: file.slice(i, i + CHUNK) });
    onProgress(Math.min(100, Math.round(((i + CHUNK) / file.size) * 100)));
  }
  return api(`/master/platform-backups/upload/${upload_id}/complete`, { method: "POST" });
}

export function BackupUpload() {
  const qc = useQueryClient();
  const [pct, setPct] = useState(null);
  const up = useMutation({
    mutationFn: (file) => uploadChunked(file, setPct),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["platform-backups"] }); toast.success("Backup enviado · escolha Restaurar na lista para aplicar"); },
    onError: (e) => toast.error(e.message),
    onSettled: () => setPct(null),
  });
  const pick = (e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) up.mutate(f); };
  return (
    <Card className="flex flex-col gap-3" data-testid="platform-backup-upload">
      <div className="h3 flex items-center gap-2"><Upload size={16} /> Enviar backup</div>
      <p className="caption">Envie um arquivo .zip gerado aqui. Ele entra na lista abaixo e nada muda até você tocar em Restaurar.</p>
      <label className={`btn btn-secondary self-start ${up.isPending ? "opacity-60 pointer-events-none" : ""}`} data-testid="platform-backup-upload-button">
        <Upload size={15} /> {up.isPending ? "Enviando…" : "Escolher arquivo .zip"}
        <input type="file" accept=".zip,application/zip" className="hidden" onChange={pick} data-testid="platform-backup-file-input" />
      </label>
      {pct !== null && (
        <div className="flex items-center gap-3" data-testid="platform-backup-upload-progress">
          <div className="flex-1 h-2 rounded-full overflow-hidden" style={{ background: "var(--surface-alt)" }}><div className="h-full" style={{ width: `${pct}%`, background: "var(--brand)", transition: "width .2s" }} /></div>
          <span className="caption tnum">{pct}%</span>
        </div>
      )}
    </Card>
  );
}
